import React, { useEffect, useState } from "react";
import ProgramBanner from "./components/programBanner/programBanner";
import styles from "./plp-promotion-list.scss";
import { useSelector } from "react-redux";
import TopBanner from "../../common/components/topBanner/topBanner";
import BreadCrumbs from "../../common/components/breadCrumbs/breadCrumbs";
import { trackPage, PAGES } from "@tw/shared-ui-components/lib/utils/analytics";
import { USER_ALL_PROMOTIONS_LIST } from "@tw/shared-ui-components/lib/utils/Constants/Constants"
function PlpPromotionList({ Link }) {
  //Getting valid promotion list
  const promotionLists = useSelector(
    (state) => state.plpState && state.plpState.promotionLists
  );

  // tealium analytics
  useEffect(() => {
    // TEAL-2330
    let timer;
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      let times = 0;
      timer = setInterval(async () => {
        if (window?.utag) {
          clearInterval(timer)
          await trackPage(PAGES.promotionList);
        } else {
          if (times >= 20) {
            clearInterval(timer)
          }
          times++
        }
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, []);
  /**
   * @description: TEP-16443
   *  1、遍历所有的特惠活動
   *  2、检查特惠活動 preReleasePromotionCode 认购配额属性是否存在 【是】检查用户是否满足活动配额【否】表示为一般特惠活動默认显示
   *  3、检查用户是否有活动配额【是】将特惠活動 preReleasePromotionCode 认购配额与用户活动配额进行匹配【否】表示当前用户不满足活动配额
  */
  const [PROMOTIONS_LIST, setPromotionLists] = useState(null)
  useEffect(() => {
    if (promotionLists && typeof window !== 'undefined' && typeof window !== undefined) {
      promotionLists.tier1.map((item) => {
        return onCheckUserActivityQuota(item)
      })
      promotionLists.tier2.map((item) => {
        return onCheckUserActivityQuota(item)
      })
      setPromotionLists(promotionLists)
    }
  }, [promotionLists])
  /**
   *  检查用户是否满足活动配额
  */
  const onCheckUserActivityQuota = (item) => {
    const PROMOTIONS_LIST = localStorage.getItem(USER_ALL_PROMOTIONS_LIST) ? JSON.parse(localStorage.getItem(USER_ALL_PROMOTIONS_LIST)) : []
    const userAllPromotionsList = PROMOTIONS_LIST.map((item) => item.activityCode);
    if (item.preReleasePromotionCode && item.preReleasePromotionCode.length > 0) {
      //  当用户未登录 或 没有配额时直接不显示活动
      if (userAllPromotionsList && userAllPromotionsList.length > 0) {
        item.isShowDomNode = item.preReleasePromotionCode.length === userAllPromotionsList.length && arraysHaveSameElements(item.preReleasePromotionCode, userAllPromotionsList);
      } else {
        item.isShowDomNode = false
      }
    } else {
      // 如果 CS 没有配置 preReleasePromotionCode 数据，表示不需要针对用户纬度显示
      item.isShowDomNode = true
    }
    return item
  }
  // 使用 Set 和数组的长度来检查两个数组是否包含相同的元素
  const arraysHaveSameElements = (arr1, arr2) => {
    // 转换数组为 Set，自动去重并忽略顺序
    const set1 = new Set(arr1);
    const set2 = new Set(arr2);
    // 比较两个 Set 是否相等
    return set1.size === set2.size && [...set1].every(value => set2.has(value));
  }
  /**
   * @description TEP-16443 END
  */
  return (
    <div className={styles["container"]}>
      <div className={styles["top-banner-wrapper"]}>
        <TopBanner
          heading="特惠活動"
          backgroundColor="#F0F9FF"
          displayProductCount={false}
        />
      </div>
      <div className={styles["breadcrumbs-wrapper"]}>
        <BreadCrumbs
          list={[{ categoryName: "首頁", link: "/" }]}
          lastChildName="特惠活動"
          Link={Link}
        />
      </div>
      <div className={styles["banner-list"]}>
        {PROMOTIONS_LIST && PROMOTIONS_LIST?.tier1.map((banner, i) => (
          banner.isShowDomNode &&
          <div className={styles["tier1-banner-wrapper"]} key={i}>
            <ProgramBanner banner={banner} key={i} type="tier1" Link={Link} />
          </div>
        ))}
      </div>
      <div className={styles["banner-list"]}>
        {PROMOTIONS_LIST && PROMOTIONS_LIST?.tier2
          .map((banner) => ({ ...banner, desc2: undefined }))
          .map((banner, i) => (
            banner.isShowDomNode &&
            <div className={styles["tier2-banner-wrapper"]} key={i}>
              <ProgramBanner banner={banner} key={i} type="tier2" Link={Link} />
            </div>
          ))}
      </div>
    </div>
  );
}

export default PlpPromotionList;
